

<template>
  <div class="container">
    <div class="col-md-12">
      <div v-if="isProductLoading" class="text-center">
        <grid-loader
          :loading="isProductLoading"
          :color="loaderColor"
          :size="loaderSize"
          class="d-inline-block"
        />
      </div>
      <div v-else class="card">
        <div class="row mycard">
          <div class="col-12 col-md-6 offset-md-3"> 
            <!-- offset-md-4 -->
            <div class="carouseldiv site-overview-wrap">
              <b-carousel
                id="carousel-fade"
                style="text-shadow: 0px 0px 2px #000"
                :interval="5000"
                img-width="500"
                img-height="500"
                fade
                controls
                indicators
              >
              <b-carousel-slide v-for="img_url in item.thumbnail_url" :item="img_url" :key="img_url" caption=""
                  :img-src="img_url" >
              </b-carousel-slide>
<!-- 
              <b-carousel-slide
                  caption=""
                  :img-src="item.thumbnail_url[0]"
                ></b-carousel-slide>
                <b-carousel-slide
                  caption=""
                  img-src="https://picsum.photos/1024/480/?image=12"
                ></b-carousel-slide>
                <b-carousel-slide
                  caption=""
                  img-src="https://i.imgur.com/UHDsikK.png"
                ></b-carousel-slide> -->
              </b-carousel>
            </div>


            <!-- <div class="intrinsic">
              <img class="img-fluid intrinsic-item" :src="item.thumbnail_url[0]" alt />
            </div> -->
          </div>
        </div>

        <div class="caption-full">
          <h4 class="pull-right">$ {{ item.price }}</h4>
          <h4>{{ item.title }}</h4>
          <p v-html="item.description"></p>
        </div>
        <div class="ratings">
          <span>{{ item.quantity }} left in stock</span>
          <p class="pull-right">
            <button
              @click="addItem"
              :disabled="item.quantity === 0"
              class="btn btn-success"
            >加入購物車</button>
          </p>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GridLoader from "vue-spinner/src/GridLoader.vue";

export default {
  components: {
    GridLoader
  },
  data() {
    return {
      loaderColor: "#5cb85c",
      loaderSize: "50px"
    };
  },
  computed: {
    ...mapGetters(["isProductLoading", "products"]),
    item() {
      let id = this.$route.params.id;
      if (this.products.length >= id) {
        let filterArr = this.products.filter(item => {
          return item.id == id;
        });
        if (filterArr.length > 0) {
          return filterArr[0];
        }
      }
      return {};
    }
  },
  methods: {
    ...mapActions(["updateCart"]),
    addItem() {
      const order = {
        item: Object.assign({}, this.item),
        quantity: 1,
        isAdd: true
      };
      // console.log(order);
      this.updateCart(order);
    }
  }
};

</script>



<style scoped>
.caption-full {
  padding-right: 10px;
  padding-left: 10px;

  padding-top: 10px;
}

.ratings {
  padding-right: 10px;
  padding-left: 10px;
  color: #d17581;
}
.carouseldiv{
  /* max-height: 500px;  */
  /* height: 500px; */
  display: block; /*added*/
  /* overflow-y: scroll; */
}
.carouseldiv img{
  margin:auto;
}

.site-overview-wrap::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #F5F5F5;
    border-radius: 10px;
}

.site-overview-wrap::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
}

.site-overview-wrap::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-image: -webkit-gradient(linear, left bottom, left top, from(#a8edea), to(#fed6e3));
    background-image: -webkit-linear-gradient(bottom, #a8edea 0%, #fed6e3 100%);
    background-image: linear-gradient(to top, #a8edea 0%, #fed6e3 100%);
}

</style>
